import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ApplicationState {
  applicationName: string
}

const initialState: ApplicationState = {
  applicationName: '',
}

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    setApplicationName(state, action: PayloadAction<string>) {
      state.applicationName = action.payload
    },
    clearApplicationName(state) {
      state.applicationName = ''
    },
  },
})

export const { setApplicationName,clearApplicationName } = applicationSlice.actions
export default applicationSlice.reducer
